import {ConnectBasicEntityExt} from '../../framework/message/ConnectBasicEntityExt';

export class WorkingTable extends ConnectBasicEntityExt {
inOutTable: string;
processCode: string;
stepCode: string;
visionCode: string;
}

